import { gql } from '@/__generated__';
import { createBlock } from '@/lib/parsers/blocks';
import { excludeEmptyTypedElements } from '@liquorice/utils';
import ExternalCardBlockOverview from '../ExternalCardBlock/ExternalCardBlock.Overview';
import OverviewCardBlock from '../OverviewCardBlock';

export const OVERVIEW_CARDS_BLOCK_FRAGMENT = gql(`
  fragment overviewCardsBlock on blocks_overviewCards_BlockType {
    overviewCardMultiple {
      ...overviewCardBlock
      ...externalCardBlock
    }
  }
`);

export const OverviewCardsBlock = createBlock(OVERVIEW_CARDS_BLOCK_FRAGMENT, ({ data, meta }) => {
  const items = excludeEmptyTypedElements(data.overviewCardMultiple);

  return (
    <>
      {items?.map(
        (item, i) => (
          item.__typename === 'entryCard_Entry' && (
            <OverviewCardBlock data={item} parentMeta={meta} key={i} />
          ),
          item.__typename === 'externalCard_Entry' && (
            <ExternalCardBlockOverview data={item} parentMeta={meta} key={i} />
          )
        )
      )}
    </>
  );
});

export default OverviewCardsBlock;
